import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { strings } from 'APP_ROOT/localization';
import moment from 'moment';
import 'moment-duration-format';
import { ModalLoadingPage } from 'APP_ROOT/components/common/loadingPage';
import EventSection from './EventSection';
import LiveStream from 'APP_ROOT/components/pages/dashboard/LiveStream/LiveStream'; /* index.js for redux is not available yet */
import EventMedia from 'APP_ROOT/components/pages/dashboard/EventMedia';
import EventClusterMediaCarousel from 'APP_ROOT/components/pages/dashboard/EventMedia/EventClusterMediaCarousel';
import { EVENT_MEDIA_REQUEST_TYPE } from  'APP_ROOT/components/pages/dashboard/EventMedia/eventMediaConstants';
import TripReportSection from './TripReportSection';

import {RESOURCE_DETAILS_VEHICLE_INFO_UNIQUE_ID,
    RESOURCE_DETAILS_EVENT_SECTION_UNIQUE_ID,
    printResourceDetailsForTrip} from 'APP_ROOT/components/common/printUtil';

export default class CardDetailsPanel extends Component {

    constructor(props) { 
        super(props);

        this.state = {
            liveStream: false,
        };
    }

    onLiveStream = (cameraType, streamStartDate = null) => {
        this.setState({
            liveStream: true,
            liveStreamCameraType: cameraType,
            liveStreamStartDate: streamStartDate
        });
    }

    onCloseLiveStream = () => {
        this.setState({liveStream: false});
    }

    render() {

        if (this.props.loading) {
            return (
                <div className="details-panel">
                    <ModalLoadingPage message={strings.resource_details_loading} style="light-theme-invert" />
                </div>
            );
        }
        if (!this.props.card) {
            return (
                <div className="centered-container">
                    <h4>{strings.history_select_a_card_above_to_see_its_details_here}</h4>
                </div>
            );
        } else if (!this.props.card.events) {
            return (
                <div className="centered-container">
                    <h3 className="error-message">{strings.history_card_load_error_description}</h3>
                </div>
            );
        } else {

            /* set report component: */

            var reportPanelComponent;
            if (this.props.card.type === "TRIP") {
                reportPanelComponent = this.props.unitOfMeasure ? (
                    <TripReportSection
                        id={RESOURCE_DETAILS_VEHICLE_INFO_UNIQUE_ID} // ref={this.vehicleInfoPrintRef} REACT REFS over-complicate accessing innerHTML
                        user={this.props.user}
                        raven={this.props.raven}
                        features={this.props.features}
                        card={this.props.card}
                        assignDriver={this.props.assignDriver}
                        setDriverName={this.props.setDriverName}
                        unitOfMeasure={this.props.unitOfMeasure}
                    />
                ) : null;
            } else if (this.props.card.type === "PARKED") {

                var parkedHeading = strings.parked_heading;

                if (this.props.card.end.ts) {
                    const startDate = new Date(this.props.card.start.ts);
                    const endDate = new Date(this.props.card.end.ts);
                    parkedHeading = strings.formatString(strings.parked_for_x_duration, moment.duration(endDate - startDate).humanize())
                }

                reportPanelComponent = (<div className="col-12 info-panel" id={RESOURCE_DETAILS_VEHICLE_INFO_UNIQUE_ID}>
                                            <h3>{parkedHeading}</h3>
                                        </div>);
            } else {
                reportPanelComponent = (<div className="col-12 info-panel" id={RESOURCE_DETAILS_VEHICLE_INFO_UNIQUE_ID}></div>);
            }

            let mediaRequestType = EVENT_MEDIA_REQUEST_TYPE.NONE;
            if (this.props.features.media_request && this.props.raven.canRequestMedia && this.props.raven.apiProfile) {
                if (this.props.raven.apiProfile.userMediaRequest) {
                    mediaRequestType = EVENT_MEDIA_REQUEST_TYPE.USER_MEDIA_REQUEST;
                } else if (this.props.raven.apiProfile.videoPreviewRequest) {
                    mediaRequestType = EVENT_MEDIA_REQUEST_TYPE.VIDEO_PREVIEW_REQUEST;
                }
            }

            let clusterEvents;
            if (this.props.selectedEvent && this.props.selectedEvent.clustered) {

                let clusterStartIndex = this.props.card.events.findIndex((event) => {return event === this.props.selectedEvent;}) - this.props.selectedEvent.clusterOffsetIndex;

                const clusterFirstEvent = this.props.card.events[clusterStartIndex];
                clusterEvents = this.props.card.events.slice(clusterStartIndex, clusterStartIndex + clusterFirstEvent.clusterSize);
                
            }

            return (
                <div className="card-details-panel">
                    {reportPanelComponent}
                    <EventSection
                        id={RESOURCE_DETAILS_EVENT_SECTION_UNIQUE_ID} // ref={this.eventSectionPrintRef} REACT REFS over-complicate accessing innerHTML
                        ravenUuid={this.props.raven.ravenUuid}
                        features={this.props.features}
                        card={this.props.card /* for segments, speedZones */}
                        cardVideoAvailabilityStartDate={this.props.cardVideoAvailabilityStartDate}
                        unitOfMeasure={this.props.unitOfMeasure}
                        events={this.props.card.events}
                        enhancedVideoAccessModeActive={this.props.enhancedVideoAccessModeActive}
                        toggleEnhancedVideoAccessModeActive={this.props.toggleEnhancedVideoAccessModeActive}    
                        selectedEvent={this.props.selectedEvent}
                        onSelectEvent={this.props.onSelectEvent}
                        mediaRequestType={mediaRequestType}
                        print={printResourceDetailsForTrip}
                    />

                    { this.props.features.media_view && this.props.raven.canViewMedia ?  
                      <> { 
                        this.props.selectedEvent ?
                            <div className="multi-panel-wrapper">
                                {this.props.selectedEvent.clustered ?
                                    <EventClusterMediaCarousel
                                        events={clusterEvents}
                                        onSelectEvent={this.props.onSelectEvent}
                                        selectedRavenUuid={this.props.raven.ravenUuid}
                                        selectedEvent={this.props.selectedEvent}
                                        mqttService={this.props.mqttService}
                                        features={this.props.features}
                                        mediaRequestType={mediaRequestType}
                                        onLiveStream={this.onLiveStream}
                                        offline={this.props.ravenOffline}
                                    />
                                :
                                    <EventMedia
                                        selectedRavenUuid={this.props.raven.ravenUuid}
                                        selectedEventId={this.props.selectedEvent && this.props.selectedEvent.eventId}
                                        mqttService={this.props.mqttService}
                                        features={this.props.features}
                                        mediaRequestType={mediaRequestType}
                                        onLiveStream={this.onLiveStream}
                                        offline={this.props.ravenOffline}
                                    />
                                }

                                {this.props.selectedEvent.type.endsWith("_STREAMING") === false ? // add another panel to the "multi-panel-wrapper" children?
                                    <EventMedia
                                        shouldShowAlternateCameraType={true}
                                        selectedRavenUuid={this.props.raven.ravenUuid}
                                        selectedEventId={this.props.selectedEvent && this.props.selectedEvent.eventId}
                                        mqttService={this.props.mqttService}
                                        features={this.props.features}
                                        mediaRequestType={mediaRequestType}
                                        onLiveStream={this.onLiveStream}
                                        offline={this.props.ravenOffline}
                                    />
                                :
                                    null // streaming playback does not support two separate cameras (or it is a clustered component if multiple streaming events on the same timestamp)
                                }
                            </div>
                        :
                            null

                        /* end media_view */
                        } </> : null
                    }
                    {this.props.features.media_view && this.props.raven.canViewMedia && this.state.liveStream ?
                        <LiveStream
                            stage={this.props.user.stage} 
                            ravenUuid={this.props.raven.ravenUuid}
                            vehicleName={this.props.raven.vehicle.name}
                            onClose={this.onCloseLiveStream}
                            defaultCamera={this.state.liveStreamCameraType}
                            startDate={this.state.liveStreamStartDate}
                            offline={this.props.ravenOffline}
                            loadingDelegate={null}
                        /> : null
                    }

                </div>
            );
        }
    }
}

CardDetailsPanel.propTypes = {
    user: PropTypes.object,
    raven: PropTypes.object,
    card: PropTypes.object,
    cardVideoAvailabilityStartDate: PropTypes.instanceOf(Date),
    loading: PropTypes.bool,
    selectedEvent: PropTypes.object,
    onSelectEvent: PropTypes.func.isRequired,
    mqttService: PropTypes.object,
    features: PropTypes.shape({
        media_request: PropTypes.bool,
        facial_recognition: PropTypes.bool
    }).isRequired,
    assignDriver: PropTypes.func.isRequired,
    unitOfMeasure: PropTypes.oneOf(['METRIC','IMPERIAL']).isRequired,
};
